import { ApiBaseService } from '../api-base.service';
import { MainStyleDto } from '../_dtos/projects.dto';
import { Injectable } from '@angular/core';
import { DataResponse } from '../_dtos/basic.dto';
import { HttpParams } from '@angular/common/http';

/**
 * Public Styles API Service
 * Used by clients to browse styles (without sensitive data)
 */
@Injectable({
  providedIn: 'root'
})
export class PublicStylesApiService extends ApiBaseService {
  override scope = 'styles'; // Public endpoint

  /**
   * Get styles, optionally filtered by product compatibility
   * @param productId Filter styles compatible with this product
   */
  getStyles(productId?: string) {
    let params = new HttpParams();
    if (productId) {
      params = params.set('product_id', productId);
    }
    return this.get<DataResponse<MainStyleDto[]>>(undefined, params);
  }

  getStyleOfMonth() {
    return this.get<DataResponse<MainStyleDto>>('style-of-the-month');
  }
}

